<div [class.dark-theme]="darkLightSetting === 'dark'" [class.light-theme]="darkLightSetting === 'light'"
     [class]="setTheme()"
     id="app-component">
  <router-outlet></router-outlet>
</div>
